<template>
    <div class="px-[20px] lg:px-[40px]">
        <step-options-characters-initials-buttons
            :class="{
                'mt-[24px]': index > 0,
            }"
            :main-placement="mainPlacement"
            :option="option"
            @unselect="handleSelectNothing"
            @select="selectActual"
            :scroll-to-offset="scrollToOffset"
            :scroll-to-timeout="200"
            :is-dirty="isDirty"
            :has-error-state="hasLocalErrorState"
            :all-components="allComponents"
            :has-add-remove-button="hasAddRemoveButton"
            :use-palette-color-selection="true"
            :has-image="true"
            :should-scroll-to-clicked-button="false"
            :should-show-edit-button="true"
            :remove-selected-on-add-remove-click="true"
            background-size="auto 100%"
        >
        </step-options-characters-initials-buttons>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import StepOptionsCharactersInitialsButtons from './buttons/StepOptionsCharactersInitialsButtons.vue';

    export default {
        mixins: [allStores],

        components: {
            StepOptionsCharactersInitialsButtons,
        },

        props: {
            visiblePlacementsInitials: {
                type: Array,
                required: true,
            },

            hasLocalErrorState: {
                type: Boolean,
                required: true,
            },

            isDirty: {
                type: Boolean,
                default: false,
            },

            isActive: {
                type: Boolean,
                default: false,
            },

            hasAddRemoveButton: {
                type: Boolean,
                default: false,
            },

            scrollToOffset: {
                type: Number,
                default: 24,
            },
        },

        computed: {
            isMobile() {
                return this.appStore?.isMobile;
            },

            anyPaintfillSelected() {
                return this.customizerStore.isAnyPaintfillSelected();
            },

            viewController() {
                return this.customizerStore.viewController;
            },

            allComponents() {
                const fullMainPlacement = this.visiblePlacementsInitials.find((x) => x.code === 'StampingStyle');

                return fullMainPlacement.components;
            },

            mainPlacement() {
                const fullMainPlacement = this.visiblePlacementsInitials.find((x) => x.code === 'StampingStyle');

                // const nonBlankComponent = fullMainPlacement.components.find((x) => !x.code.includes('Blank'));

                // nonBlankComponent.description[0].name = 'Initials';

                const singleMainPlacement = {
                    ...fullMainPlacement,
                    // components: [nonBlankComponent],
                };

                return singleMainPlacement;
            },

            optionalPlaceholder() {
                return this.mainPlacement.components.find(
                    (x) => x.placeholder
                        && this.viewController.isAvailable(x)
                        && x.placeholderOptional,
                )?.code;
            },

            nonOptionalPlaceholder() {
                return this.mainPlacement.components.find(
                    (x) => x.placeholder
                        && this.viewController.isAvailable(x)
                        && !x.placeholderOptional,
                )?.code;
            },

            styleOptions() {
                return this.customizerStore.sortOptions(this.mainPlacement, this.selectedValue);
            },

            selectedValue() {
                return this.mainPlacement.selectedValue;
            },

            visiblePlacementsInitialsColors() {
                if (!Array.isArray(this.visiblePlacementsInitials)) {
                    return [];
                }

                return this.visiblePlacementsInitials
                    .filter((placement) => placement?.code?.includes('Color'));
            },
        },

        watch: {
            visiblePlacementsInitialsColors: {
                immediate: true,
                deep: true,
                handler(nextPlacements) {
                    this.customizerStore.syncFrontInitialsSubOptionsFromPlacements(nextPlacements);
                },
            },
        },

        mounted() {
        },

        methods: {
            async handleSelectNothing() {
                this.customizerStore.resetCharacterStamping();
                this.$emit('unselect');
            },

            async selectActual({ placement, option }) {
                this.customizerStore.selectStampingStyle(placement, option);
                this.$emit('select', option);

                this.customizerStore.setActiveView('Face');
            },
        },
    };
</script>
